import { render, staticRenderFns } from "./SimpleProposalHeader.vue?vue&type=template&id=055b1e8f&scoped=true&"
import script from "./SimpleProposalHeader.vue?vue&type=script&lang=js&"
export * from "./SimpleProposalHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055b1e8f",
  null
  
)

export default component.exports